<script>
  import { createEventDispatcher } from "svelte";
  export let letter = ''
  export let location = 0
  export let selected = []
  const dispatch = createEventDispatcher()

  const select = () => {
    dispatch('selectTile', { letter, location })
  }
  let isSelected = false
  $: isSelected = selected.findIndex(t => t.location === location) !== -1
  </script>
  
  <div class="relative mx-1 text-4xl leading-[80px] font-mono" on:click={select}>
    {#if selected[selected.length - 1]?.location === location}
      <div class="absolute top-0 right-0 text-xs bg-white h-2 w-2 rounded-full m-1" />
    {/if}
    
    <div class="border">
      <div class={`${ isSelected ? 'bg-teal-700 text-white' : 'bg-gray-100'}`}>{ letter }</div>
    </div>
  </div>
  <div class="hidden bg-gray-100 bg-gray-300 bg-gray-500 bg-green-600 bg-yellow-500 text-white"></div>
  